import * as yup from "yup";

yup.addMethod(yup.number,'nanable',function nanable() {
  return this.transform((value) => (isNaN(value) ? null : value));
});
